export default "__VITE_ASSET__4GMhQKt3__"